import { render } from "./TsHero.vue?vue&type=template&id=355ea7d2&scoped=true"
import script from "./TsHero.vue?vue&type=script&lang=js"
export * from "./TsHero.vue?vue&type=script&lang=js"

import "./TsHero.vue?vue&type=style&index=0&id=355ea7d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-355ea7d2"]])

export default __exports__